import JSONRPCAPI from './JSONRPCAPI';
import transferActions from 'js/redux/reducers/Transfer';
import type {
  TransferContent,
  TransferQtObject,
  TransferStore,
  TransferWriteResponse,
} from './types/Transfer';

export type {
  TransferContent,
  TransferQtObject,
  TransferStore,
  TransferWriteResponse,
} from './types/Transfer';

export class TransferAPI extends JSONRPCAPI {
  connect(qtobject: TransferQtObject, store?: TransferStore): void {
    super.connect(qtobject);
    try {
      qtobject.addOrder?.connect((str: string) => {
        store?.dispatch(transferActions.addOrder(JSON.parse(str)));
      });
    } catch (e) {
      // Older version of POS app doesn't export this
    }
  }
  writeFlink(content: TransferContent): Promise<TransferWriteResponse> {
    return this.jsonrpc.request<TransferWriteResponse>('write_flink', [
      content,
    ]);
  }
}

const api = new TransferAPI();

export { api as default };
